import { createAction, props } from '@ngrx/store';
import { Schema } from '../models/search.model';
import { HttpErrorResponse } from '@angular/common/http';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';

export const FlowRecipesData = createAction('[Recipes: Search]: Search Field Data');

export const RecipeTypesSuccess = createAction(
  '[Recipes: Search]: Rule Types Success',
  props<{ recipeTypes: string[] }>(),
);
export const RecipeTypesFailure = createAction(
  '[Recipes: Search]: Rule Types Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const RecipeCodesSuccess = createAction(
  '[Recipes: Search]: Rule Codes Success',
  props<{ recipeCodes: string[] }>(),
);
export const RecipeCodesFailure = createAction(
  '[Recipes: Search]: Rule Codes Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const SchemaSuccess = createAction('[Recipes: Search]: Schema Success', props<{ schemas: Schema[] }>());

export const SchemaFailure = createAction('[Recipes: Search]: Schema Failure', props<{ error: HttpErrorResponse }>());

export const PanelExpansionChanged = createAction('[Recipes: Search]: Panel Expansion Changed');

export const RecipeTypeChanged = createAction(
  '[Recipes: Search]: Rule Type Changed',
  props<{ selectedRecipeType: string }>(),
);

export const RecipeNameChanged = createAction(
  '[Recipes: Search]: Rule Name Changed',
  props<{ selectedRecipeName: string }>(),
);

export const ActiveChanged = createAction('[Recipes: Search]: Active Changed', props<{ active: boolean }>());

export const DeletedChanged = createAction('[Recipes: Search]: Deleted Changed', props<{ deleted: boolean }>());

export const StartDateChanged = createAction(
  '[Recipes: Search]: Start Date Changed',
  props<{ selectedStartDate: string }>(),
);

export const StartDateCleared = createAction('[Recipes: Search]: Start Date Cleared');

export const EndDateChanged = createAction(
  '[Recipes: Search]: End Date  Changed',
  props<{ selectedEndDate: string }>(),
);

export const EndDateCleared = createAction('[Recipes: Search]: End Date Cleared');

export const ClearSearchOptions = createAction('[Recipes: Search]: Clear Search Options');

export const ActivateRecipe = createAction('[Recipes: Search]: Activate Recipe', props<{ recipe: any }>());

export const ActivateRecipeSuccess = createAction('[Recipes: Search]: Activate Recipe Success');

export const ActivateRecipeFailed = createAction('[Recipes: Search]: Activate Recipe Failed');

export const DeactivateRecipe = createAction('[Recipes: Search]: Deactivate Recipe', props<{ recipeCode: string }>());

export const DeactivateRecipeSuccess = createAction('[Recipes: Search]: Deactivate Recipe Success');

export const DeactivateRecipeFailed = createAction('[Recipes: Search]: Deactivate Recipe Failed');

export const OpenDeactivateRecipeModal = createAction(
  '[Recipes: Search]: Open Deactivate Recipe Modal',
  props<{ recipeCode: string }>(),
);

export const OpenActivateRecipeModal = createAction(
  '[Recipes: Search]: Open Activate Recipe Modal',
  props<{ recipe: any }>(),
);

export const RecipeGridSuccess = createAction(
  '[Recipes: Search]: Recipe Grid Success',
  props<{ result: QcResponseGrid }>(),
);

export const RecipeSearchCount = createAction('[Recipes: Search]: Recipe Search Count');

export const RecipeSearchCountFailed = createAction(
  '[Recipes: Search]: Recipe Search Count Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const OpenSideNav = createAction('[Recipes: Search]: Open Edit Recipe');

export const CloseSideNav = createAction('[Recipes: Search]: Close Edit Recipe');

export const EditRecipe = createAction('[Recipes: Search]: Edit Recipe Data', props<{ row: any }>());
